import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';

class AddProjRoleTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            listOfUsers: ([{id:1, label: "John Smith"},{id:1, label: "Peter Novak"},{id:1, label: "Somebody Else"}]),
            listOfCountry: ([{id:1, label: "Czech republic"},{id:1, label: "United States"},{id:1, label: "Ukraine"}]),
            listOfRoles: ([{id:1, label: "CTL approvement"},{id:1, label: "Reasonability Pre-check"},{id:1, label: "GT approvement"}]),
            selectedCountry: 0,
            selectedRole: 0,
            selectedUser: 0,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {


    }

    createNewRole = () => {
        alert("I will create new role");
    }

    editExistingRole = () => {
        alert("I will edit existing role with ID: "+this.props.editRole);
        this.props.setEditRole(0);
    }

    render() {
        return (
            <div className={"universalAddTile"} style={{position: "relative"}}>
                {this.props.editRole == 0 ? <span className="fontPoppinsSemiBold15 clickable">Add Role</span> : null }
                {this.props.editRole > 0 ? <span className="fontPoppinsSemiBold15 clickable">Edit Role</span> : null }

                <div style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20}}>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Select User:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="user" id="user" style={{}} value={this.state.selectedUser} onChange={e => this.setState({ selectedUser: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfUsers.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Select Role:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="role" id="role" style={{}} value={this.state.selectedRole} onChange={e => this.setState({ selectedRole: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfRoles.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Select Country:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="country" id="country" style={{}} value={this.state.selectedCountry} onChange={e => this.setState({ selectedCountry: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfCountry.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="horizontalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25, paddingBottom: 20}}>
                        {this.props.editRole == 0 ? <RoundButton title={"Add Role"} className={"roundButtonOrange"} onClick={this.createNewRole} whiteText={true} /> : null }
                        {this.props.editRole > 0 ? <RoundButton title={"Edit Role"} className={"roundButtonOrange"} onClick={this.editExistingRole} whiteText={true} /> : null }
                    </div>
                </div>

            </div>
        );
    }
}

export default AddProjRoleTile;
